import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { ACTIVATION_FLOW, HBO, HIGHLIGHT } from '../../constants';
import { resolveIsHBOActivation } from 'src/utils/Utils';
import store from '../../../../store';
import { SUPERDESTACADOS } from 'src/utils/trackers/GA4Constants';
import Utils from '../../../../utils/Utils';
import { QR_ACTIVATION_CONFIG_HBO_DEFAULT } from '../../constants';
import { showModalActivaHBOMaxQR } from '../../../CardNew/utils.js';

class RibbonHighlight extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.ribbonIndex = props.index;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.navItems = store.getState().navbar;
        this.ribbonName = props.ribbonName || props.ribbonId;
        this.device = props.device;
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;
        this.qrActivationConfigHBO = Utils.getRegionaliazedMetadata('qr_activation_config', QR_ACTIVATION_CONFIG_HBO_DEFAULT);
    }

    resolveCardType(item) {
        let isLiveTV = false;
        if (item.type && item.type == 'live') {
            if (item.live_enabled && item.live_enabled == 1) {
                isLiveTV = true;
            }
        }

        return isLiveTV ? 'a' : '';
    }

    clickHandler(data) {
        this.onClickHandler && this.onClickHandler(data);
    }

    async clickHandlerHBOActivation(data, e) {
        const isHBOActivation = resolveIsHBOActivation(data.type_initial_flow, data.external_activation_app, data.url);
         if(isHBOActivation) {
            e.preventDefault();
            e.stopPropagation();
            showModalActivaHBOMaxQR(this.qrActivationConfigHBO);
        } else return
    }

    render() {
        return (
            <div className="ribbon-items ribbon-highlight">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    const uri = node_item.src;
                    const cardType = this.resolveCardType(node_item);
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.carruselTitle || this.ribbonId,
                    };
                    const coverResize = this.device === 'ps4' ? `${node_item.cover}?impolicy=resize&vwidth=900` : node_item.cover;
                    let cardProps = {
                        ribbonLength: this.visibleItems.length,
                        unFocusHandler: this.unFocusHandler,
                        id: index + 1,
                        ribbonId: this.ribbonId,
                        key: key,
                        ribbonIndex: this.ribbonIndex,
                        ignoreSeenLast: this.ignoreSeenLast,
                        data: node_item,
                        group_id: node_item.group_id || node_item.id,
                        cover: coverResize,
                        hideTitles: this.props.hideTitles,
                        label: node_item.label,
                        type: HIGHLIGHT,
                        title: node_item.title,
                        badges: badges,
                        typeRender: cardType,
                        dataMetric: {
                            carruselTitle: this.carruselTitle,
                            cardPosition: GeneralRibbonUtils.getPosition(
                                this.items,
                                node_item.title
                            ),
                        },
                        focusable: index === 1,
                        focusRight: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusLeft: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusHandler: this.focusHandler,
                        setMetricsEvent: this.setMetricsEvent,
                        clickHandler: node_item.clickHandler || this.onClickHandler,
                        sibling: node_item.sibling,
                        href: uri,
                        hideInnerTitle: this.hideInnerTitle,
                        keyDownHandler: this.keyDownHandler,
                        ribbonName: this.ribbonName,
                        metricG4Ads: SUPERDESTACADOS,
                        onClick:
                            cardType === 'a'
                                ? (e) => {
                                      this.dataUpdateMetrics(dataMetricsRibbon);

                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.clickHandler(node_item);
                                  }
                                : (e) => {
                                      this.dataUpdateMetrics(dataMetricsRibbon);
                                      this.clickHandlerHBOActivation(node_item, e);
                                  },
                      idsRibbonsUpAndDown: this.idsRibbonsUpAndDown
                    };
                    return <Card {...cardProps} />;
                })}
            </div>
        );
    }
}

export default RibbonHighlight;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonHighlight/index.jsx